var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1708_21243)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#4972F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1708_21243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1708_21243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3973 15.8094H17.3995V11.1495C17.3995 10.8671 17.2873 10.5963 17.0876 10.3967C16.8879 10.197 16.6171 10.0848 16.3347 10.0848H7.66472C7.38235 10.0848 7.11154 10.197 6.91187 10.3967C6.7122 10.5963 6.60004 10.8671 6.60004 11.1495V15.8094H6.60212C6.60212 15.8247 6.59912 15.8394 6.59912 15.8544C6.59912 18.3237 9.01712 20.3244 11.9991 20.3244C14.9811 20.3244 17.3991 18.3228 17.3991 15.8544C17.4003 15.8391 17.3973 15.8244 17.3973 15.8094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 3.675C10.9936 3.70276 10.0388 4.12193 9.33805 4.84323C8.63727 5.56453 8.24583 6.53093 8.24707 7.5366C8.24707 8.2428 8.25427 8.8038 8.26117 9.3432H9.68075C9.67355 8.8074 9.66665 8.2464 9.66665 7.5366C9.65235 7.22123 9.70213 6.90623 9.81295 6.61063C9.92378 6.31503 10.0934 6.04496 10.3115 5.81673C10.5296 5.5885 10.7917 5.40684 11.082 5.28273C11.3723 5.15862 11.6847 5.09464 12.0004 5.09464C12.3161 5.09464 12.6285 5.15862 12.9188 5.28273C13.209 5.40684 13.4711 5.5885 13.6893 5.81673C13.9074 6.04496 14.077 6.31503 14.1878 6.61063C14.2986 6.90623 14.3484 7.22123 14.334 7.5366L14.3305 9.3432H15.7504L15.754 7.5366C15.755 6.53042 15.363 5.56362 14.6616 4.84227C13.9601 4.12092 13.0047 3.70207 11.9989 3.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.761 16.747C11.621 16.7469 11.4867 16.6912 11.3877 16.5922C11.2887 16.4932 11.2331 16.359 11.233 16.219V14.8741C11.0045 14.7115 10.8336 14.4805 10.745 14.2144C10.6564 13.9483 10.6546 13.661 10.74 13.3939C10.8253 13.1267 10.9934 12.8936 11.2199 12.7282C11.4463 12.5629 11.7195 12.4737 11.9999 12.4737C12.2804 12.4737 12.5536 12.5629 12.78 12.7282C13.0065 12.8936 13.1745 13.1267 13.2599 13.3939C13.3452 13.661 13.3435 13.9483 13.2549 14.2144C13.1663 14.4805 12.9954 14.7115 12.7669 14.8741V16.2184C12.7668 16.3584 12.7112 16.4926 12.6122 16.5916C12.5132 16.6906 12.3789 16.7463 12.2389 16.7464L11.761 16.747Z",
    fill: "#4972F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1708_21243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.944e68d0051ab5c99f6ad362873e3ce4.svg";
export { ForwardRef as ReactComponent };